export default __webpack_public_path__ + "static/media/1-horarios.1987ae93.svg";